import { render, staticRenderFns } from "./files.vue?vue&type=template&id=154edec2&scoped=true&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&id=154edec2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154edec2",
  null
  
)

component.options.__file = "files.vue"
export default component.exports